import { Theme } from '@emotion/react';

const color = {
  white: '#FFFFFF',
  black: '#0C0C0C',
  primary: '#0C0C0C',
  primaryHover: '#2E2F33',
  grey: '#6B7684',
  success: '#03A66D',
  successBg: '#E8F7EE',
  error: '#F04452',
  errorBg: '#FFEEEE',
  info: '#3182F6',
  infoBg: '#E8F3FF',
  disabled: '#D1D6DB',
  background: '#F2F4F6',
  surface: '#FFFFFF',
  border: '#E5E8EB',
  text: '#0C0C0C',
  textSub: '#6B7684',
  textMuted: '#8B95A1',
  grey50: '#F9FAFB',
  grey75: '#F2F4F6',
  grey100: '#E5E8EB',
  grey200: '#D1D6DB',
  grey300: '#B0B8C1',
  grey400: '#8B95A1',
  grey500: '#6B7684',
  grey600: '#4E5968',
  grey700: '#333D4B',
  grey800: '#191F28',
  grey900: '#0C0C0C',
  mainOrange: '#FD5C2B',
  lightBlue1: '#2BADEE',
  lightBlue2: '#74CFFF',
  lightBlue3: '#E2F7FF',
} as const;

const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 999,
} as const;

const shadow = {
  card: '0 1px 2px rgba(0, 0, 0, 0.04)',
  popover: '0 8px 24px rgba(0, 0, 0, 0.12)',
  modal: '0 16px 40px rgba(0, 0, 0, 0.16)',
} as const;

const theme: Theme = { color, radius, shadow };

export default theme;
